import React from "react";
import styled from "styled-components";
import SmartMissedSchool from "../../smart/MissedSchool/MissedSchool";
import SmartFeelingSick from "../../smart/FeelingSick/FeelingSick";
import { getExtendedDateFormat } from "../../../modules/constants";

const TitleWrapper = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  font-size: 26px;
  font-weight: 600;

  & > * {
    display: flex;
    margin-right: 18px;
    flex-direction: row;
  }

  @media (max-width: 647px) {
    flex-direction: column;
    & > * {
      flex-direction: column;
    }
  }
`;

const GoalIcon = styled.i`
  color: ${(props) => props?.theme?.darkPurple};
  margin-right: 10px;
  line-height: 32px;
  transform: ${(props) => props?.isRtl && "scaleX(-1)"};
`;

const Title = styled.h3`
  color: ${(props) => props?.theme?.nero};
  flex-direction: row;
  align-items: center;
`;

const ButtonSection = styled.div`
  margin-left: auto;
  margin-right: 0;
  gap: 10px;

  @media screen and (orientation: portrait) {
    align-items: end;
  }

  @media (max-width: 647px) {
    margin-top: 10px;
    button {
      min-width: 200px;
    }
  }
`;

const Date = styled.span`
  color: ${(props) => props?.theme?.gray};
  @media (max-width: 647px) {
    font-size: 23px;
  }
`;

const DailySectionTitle = ({
  label,
  date,
  dailyItemKey,
  isRtl,
  dailyEntry,
  refreshData,
}) => {
  return (
    <TitleWrapper data-testid="daily-section-title-wrapper">
      <Title>
        <GoalIcon className="fas fa-flag-checkered" isRtl={isRtl} />
        {label}
      </Title>
      <Date>{date.format(getExtendedDateFormat())}</Date>
      <ButtonSection>
        <SmartMissedSchool
          missedSchool={dailyEntry?.missedSchool}
          date={date}
          didntFeelWell={dailyEntry?.didntFeelWell}
          studyVisitOrMedicalApt={dailyEntry?.studyVisitOrMedicalApt}
          dailyItemKey={dailyItemKey}
          refreshData={refreshData}
        />
        <SmartFeelingSick
          date={date}
          sickDayDate={dailyEntry?.sickDayDate}
          isSickDay={dailyEntry?.sickDay}
          dailyItemKey={dailyItemKey}
          refreshData={refreshData}
        />
      </ButtonSection>
    </TitleWrapper>
  );
};

export default DailySectionTitle;
